module.exports = __webpack_public_path__ + "img/bg_992.996ceef0.png";